import { CommonModule } from '@angular/common';
import { NgModule, APP_INITIALIZER } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  FeatureTogglesFacade,
  FeatureToggleType,
} from '@cigna/shared/angular/features-feature';
import { CONFIG, Config } from './environment/config';
import { SESSION_ID_PROVIDER } from './session-id/session-id-provider';

export const configFeaturesFactory =
  (config: Config, features: FeatureTogglesFacade) => () => {
    features.updateFeatureToggles(config.features, FeatureToggleType.RELEASE);
  };
@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: configFeaturesFactory,
      deps: [CONFIG, FeatureTogglesFacade],
    },
    SESSION_ID_PROVIDER,
  ],
})
export class CignaForBrokersSharedUtilModule {}
